/* Zubaz FAN KIT (draft/wow lab) — self-contained features:
   1) Seasonal FX — calendar-driven particles; windows computed by the daily
      gameday cron (July 4, NFL kickoff weekend, Halloween, Thanksgiving,
      Black Friday–Cyber Monday, Christmas, Super Bowl), homepage only,
      once per session
   2) Matchup mode — gameday countdown click opens team-vs-opponent overlay
   (Size quiz, Rep-O-Meter and wallpaper generator were removed 2026-07-02
   by request.)
   Loaded from theme.liquid with data-gameday asset URL. */
(function () {
  'use strict';
  var TAG = document.getElementById('zbz-fankit-script');
  var GAMEDAY_URL = TAG ? TAG.getAttribute('data-gameday') : null;

  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function el(html) { var d = document.createElement('div'); d.innerHTML = html; return d.firstElementChild; }
  function pickedTeam() {
    var h = window.zubazGetTeam && window.zubazGetTeam();
    if (h && window.ZUBAZ_TEAMS && window.ZUBAZ_TEAMS[h]) return h;
    return null;
  }
  function pathTeam() {
    var m = location.pathname.match(/^\/collections\/([a-z0-9-]+)/);
    return (m && window.ZUBAZ_TEAMS && window.ZUBAZ_TEAMS[m[1]]) ? m[1] : null;
  }
  function nick(name) { var p = String(name).split(' '); return p[p.length - 1].toUpperCase(); }

  /* ================= 1) SEASON KIT (calendar-driven) ======================= */
  // Everything below keys off the daily gameday feed: feed.season (particle
  // windows), feed.moments (homepage spotlight rail with server-resolved
  // products), feed.sb (Super Bowl participants once known). Windows are
  // computed by the cron with REAL dates. Outside every window: regular look.
  // Preview any season today with ?zbz-season=<key prefix>, e.g.
  // ?zbz-season=christmas or ?zbz-season=gift (skips the date check).
  var FORCE = null;
  try { FORCE = new URLSearchParams(location.search).get('zbz-season'); } catch (e) { }
  var isHome = location.pathname === '/';

  function seasonKit() {
    if (!GAMEDAY_URL) return;
    var d = new Date();
    var iso = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    var hit = function (x) { return FORCE ? x.k.indexOf(FORCE) === 0 : (iso >= x.s && iso <= x.en); };
    fetch(GAMEDAY_URL).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (feed) {
      var ev = (feed.season || []).filter(hit)[0];
      if (ev) {
        if (isHome && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
          runFx(ev.fx === 'emoji' ? 'emoji' : ev.fx, ev.e || '⭐', ev.k);
        }
        applySkin(ev.k);
        logoAccessory(ev.k);
        toggleAccent(ev.k);
        cartCopy(ev.k);
      }
      if (isHome) {
        var m = (feed.moments || []).filter(hit)[0];
        if (m) { spotlight(m); heroSeason(m.k); }
        var sbActive = ev && ev.k.indexOf('superbowl') === 0;
        if (feed.sb && feed.sb.length === 2 && (sbActive || FORCE === 'superbowl')) sbTakeover(feed.sb);
      }
    }).catch(function () { });
  }

  /* ---- seasonal hero: during a merchandising window, lead the homepage
     slideshow with the season-matching slide (bibs/NFL slide for tailgate +
     Super Bowl, hoodies slide for cold weather / gift season). No matching
     slide or no active window → the merchant's slide order stands. ---- */
  function heroSeason(momentKey) {
    var want = null;
    if (/^(tailgate|superbowl)/.test(momentKey)) want = /nfl|game ?day|bib/i;
    else if (/^(cold|gift)/.test(momentKey)) want = /hoodie|fleece|cozy/i;
    if (!want) return;
    // Focal's slideshow is a <slide-show> custom element with its own
    // select(index) API (no Flickity on the homepage).
    var tries = 0;
    (function go() {
      var el2 = document.querySelector('slide-show.slideshow, .slideshow');
      if (el2 && typeof el2.select === 'function') {
        var slides = el2.querySelectorAll('.slideshow__slide');
        var idx = -1;
        slides.forEach(function (s, i) {
          var a = s.querySelector('a[href]');
          if (idx < 0 && want.test((s.textContent || '') + ' ' + (a ? a.getAttribute('href') : ''))) idx = i;
        });
        if (idx > 0 && el2.selectedIndex !== idx) el2.select(idx);
        return;
      }
      if (++tries < 25) setTimeout(go, 400);
    })();
  }

  /* ---- mobile menu personality + team accents (mobile-audit #9 + #11) ----
     Pinned "SHOP {TEAM} GEAR" entry with the team badge at the top of the
     mobile nav drawer, free-shipping line in its footer, and a --zbz-team
     CSS variable + html.zbz-has-team hook for team-colored accents. ---- */
  function fanChrome() {
    var picked = pickedTeam();
    var T = picked && window.ZUBAZ_TEAMS[picked];
    var root = document.documentElement;
    root.classList.toggle('zbz-has-team', !!T);
    if (T) root.style.setProperty('--zbz-team', T.primary);
    var drawer = document.getElementById('mobile-menu-drawer');
    if (drawer) {
      var old = drawer.querySelector('.zbz-menu-team');
      if (old && (!T || old.getAttribute('href') !== '/collections/' + picked)) { old.remove(); old = null; }
      var content = drawer.querySelector('.drawer__content');
      if (T && content && !old) {
        var a = el('<a class="zbz-menu-team" href="/collections/' + esc(picked) + '" style="--zbzt:' + T.primary + ';">' +
          (T.icon ? '<img src="' + T.icon + '&width=80" alt="" loading="lazy">' : '<span class="zbz-menu-team__ball">🏈</span>') +
          '<span>SHOP ' + esc(nick(T.name)) + ' GEAR</span><b>→</b></a>');
        content.insertBefore(a, content.firstChild);
      }
    }
  }

  /* ---- seasonal skins: accent-color shift while a window is active ---- */
  // Injected as a <style> at the END of <body> so it wins the document-order
  // fight against the team-chrome style tag (both use !important).
  var SKINS = {
    halloween: '#ff6a00',
    christmas: '#146b3a',
    bfcm: '#0aa64d'
  };
  function skinKey(k) { return k.split('-')[0]; }
  function applySkin(k) {
    var color = SKINS[skinKey(k)];
    if (!color) return;
    document.documentElement.classList.add('zbz-skin-' + skinKey(k));
    function inject() {
      if (document.getElementById('zbz-skin-style')) return;
      var st = document.createElement('style');
      st.id = 'zbz-skin-style';
      // :not(#zbz-x) inflates specificity past the team-chrome rule (which
      // uses #main + :not(class)); html:not(.zubaz-90s) keeps the Win95
      // buttons winning when the user explicitly flips '90s Mode on.
      st.textContent =
        'html:not(.zubaz-90s) #main .button--primary:not(#zbz-x), html:not(.zubaz-90s) .button--primary:not(#zbz-x) { background: ' + color + ' !important; border-color: ' + color + ' !important; color: #fff !important; }';
      document.body.appendChild(st);
    }
    inject();
    setTimeout(inject, 1500); // survive late team-chrome application
  }

  /* ---- logo accessory: 🎃 / 🎅 perched on the header logo ---- */
  var HATS = { halloween: '🎃', christmas: '🎅', thanksgiving: '🦃', superbowl: '🏈', nfl: '🏈' };
  function logoAccessory(k) {
    var hat = HATS[skinKey(k)];
    if (!hat || document.querySelector('.zbz-logo-hat')) return;
    var logo = document.querySelector('.header__logo') || document.querySelector('header a[href="/"]');
    if (!logo) return;
    if (getComputedStyle(logo).position === 'static') logo.style.position = 'relative';
    var s = document.createElement('span');
    s.className = 'zbz-logo-hat';
    s.textContent = hat;
    s.setAttribute('aria-hidden', 'true');
    logo.appendChild(s);
  }

  /* ---- '90s toggle joins the party: tiny seasonal emoji next to the text.
     The button keeps its own pink styling (it's a persistent control) —
     this is just an accent, matching the logo accessory. ---- */
  function toggleAccent(k) {
    var hat = HATS[skinKey(k)];
    if (!hat) return;
    var tries = 0;
    (function find() {
      var btn = document.querySelector('.zubaz-90s-toggle');
      if (btn) { if (btn.textContent.indexOf(hat) < 0) btn.textContent = "'90s " + hat; return; }
      if (++tries < 40) setTimeout(find, 300); // custom.js creates it async
    })();
  }

  /* ---- seasonal cart copy: one flavor line in the cart drawer ---- */
  var CART_LINES = {
    july4: 'Stars, stripes… and zebra stripes. 🎆',
    nfl: 'Gameday-ready. Cart approved. 🏈',
    halloween: 'Scary good taste in this cart. 🎃',
    thanksgiving: 'Now that’s something to be thankful for. 🦃',
    bfcm: 'Louder deals. Louder pants. 💸',
    christmas: 'Santa called — he wants a pair too. 🎅',
    superbowl: 'Big game. Bigger fits. 🏈'
  };
  function cartCopy(k) {
    var line = CART_LINES[skinKey(k)];
    if (!line) return;
    var host = document.getElementById('shopify-section-mini-cart');
    if (!host) return;
    function inject() {
      if (host.querySelector('.zbz-cart-season')) return;
      if (!host.querySelector('.zbz-fb, .line-item, [class*="line-item"], [class*="drawer"]')) return;
      var anchor = host.querySelector('.drawer__header, [class*="drawer__header"], h2');
      if (!anchor) return;
      var p = document.createElement('p');
      p.className = 'zbz-cart-season';
      p.textContent = line;
      anchor.parentNode.insertBefore(p, anchor.nextSibling);
    }
    new MutationObserver(inject).observe(host, { childList: true, subtree: true });
    inject();
  }

  /* ---- homepage spotlight rail: products resolved daily by the cron ---- */
  function cardHtml(p, width) {
    var price = p.p == null ? '' : '<b>$' + (p.p % 1 ? p.p.toFixed(2) : p.p) + '</b>';
    return '<a class="zbz-spot__card" href="/products/' + esc(p.h) + '">' +
      '<img loading="lazy" src="' + esc(p.im) + '?width=' + width + '" alt="">' +
      '<span>' + esc(p.t) + '</span>' + price + '</a>';
  }
  function homeAnchor() {
    return document.querySelector('[id$="__zbz_team_cta"]') ||
      document.querySelector('#main .shopify-section:nth-of-type(4)') ||
      document.querySelector('#main .shopify-section:last-of-type');
  }
  // Gift guide goes fully team-specific when a team is picked: rebuilt from
  // that team's own product index (same CDN asset zbz-bigfilter uses) —
  // their santa hat + holiday items interleaved with their best sellers.
  var XMAS_RE = /santa|red and green|christmas|holiday/i;
  function teamGiftProducts(handle, cb) {
    var base = GAMEDAY_URL ? GAMEDAY_URL.split('zbz-gameday.json')[0] : null;
    if (!base) return cb(null);
    fetch(base + 'zbz-filter-index-' + handle + '.json').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (d) {
      var all = (d.products || []).filter(function (p) { return !p.so && p.im; })
        .sort(function (a, b) { return (a.r === undefined ? 1e9 : a.r) - (b.r === undefined ? 1e9 : b.r); })
        .map(function (p) { return { h: p.h, t: p.t, im: d.imgBase + p.im, p: p.p }; });
      var xmas = all.filter(function (p) { return XMAS_RE.test(p.t); });
      var rest = all.filter(function (p) { return !XMAS_RE.test(p.t); });
      var out = [];
      for (var i = 0; out.length < 8 && (xmas[i] || rest[i]); i++) {
        if (xmas[i]) out.push(xmas[i]);
        if (rest[i] && out.length < 8) out.push(rest[i]);
      }
      cb(out.length >= 4 ? out : null);
    }).catch(function () { cb(null); });
  }
  function spotlight(m) {
    if (document.getElementById('zbz-spot')) return;
    var picked = pickedTeam();
    var T = picked && window.ZUBAZ_TEAMS[picked];
    function render(prods, title) {
      if (document.getElementById('zbz-spot')) return;
      var sec = el('<section class="zbz-spot" id="zbz-spot">' +
        '<p class="zbz-spot__kicker">RIGHT NOW AT ZUBAZ</p>' +
        '<h2 class="zbz-spot__title">' + esc(title || m.title) + '</h2>' +
        '<p class="zbz-spot__sub">' + esc(m.sub) + '</p>' +
        '<div class="zbz-spot__grid">' + prods.slice(0, 8).map(function (p) { return cardHtml(p, 460); }).join('') + '</div>' +
        (m.cta ? '<a class="button button--primary" href="' + esc(m.cta.href) + '">' + esc(m.cta.label) + '</a>' : '') +
        '</section>');
      var anchor = homeAnchor();
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(sec, anchor.nextSibling);
    }
    // Fallback list: feed products with the picked team's items bubbled front.
    var base = (m.products || []).slice();
    if (T) {
      var tn = T.name.toLowerCase();
      base.sort(function (a, b) {
        return (b.t.toLowerCase().indexOf(tn) >= 0 ? 1 : 0) - (a.t.toLowerCase().indexOf(tn) >= 0 ? 1 : 0);
      });
    }
    if (T && m.k === 'gift-guide') {
      teamGiftProducts(picked, function (tp) {
        render(tp || base, tp ? 'THE ' + nick(T.name) + ' FAN GIFT GUIDE' : null);
      });
      return;
    }
    render(base);
  }

  /* ---- Super Bowl takeover: both fanbases, one strip ---- */
  function sbTakeover(handles) {
    if (document.getElementById('zbz-sb') || !window.ZUBAZ_TEAMS) return;
    var A = window.ZUBAZ_TEAMS[handles[0]], B = window.ZUBAZ_TEAMS[handles[1]];
    if (!A || !B) return;
    var side = function (T, h) {
      return '<div class="zbz-sb__team">' + (T.icon ? '<img src="' + T.icon + '&width=160" alt="">' : '') +
        '<b>' + esc(nick(T.name)) + '</b>' +
        '<a class="button button--primary" href="/collections/' + esc(h) + '">SHOP ' + esc(nick(T.name)) + ' GEAR</a></div>';
    };
    var sec = el('<section class="zbz-sb" id="zbz-sb" style="--sba:' + A.primary + ';--sbb:' + B.primary + ';">' +
      '<p class="zbz-sb__kicker">SUPER BOWL WEEK</p>' +
      '<h2 class="zbz-sb__title">TWO FANBASES. ONE TROPHY. DRESS ACCORDINGLY.</h2>' +
      '<div class="zbz-sb__vs">' + side(A, handles[0]) + '<span class="zbz-sb__x">VS</span>' + side(B, handles[1]) + '</div>' +
      '</section>');
    var hero = document.querySelector('[id$="__slideshow"]');
    if (hero && hero.parentNode) hero.parentNode.insertBefore(sec, hero.nextSibling);
    else { var a = homeAnchor(); if (a && a.parentNode) a.parentNode.insertBefore(sec, a); }
  }
  function runFx(mode, emoji, key) {
    try { if (sessionStorage.getItem('zbz-fx-' + key)) return; sessionStorage.setItem('zbz-fx-' + key, '1'); } catch (e) { }
    var cv = el('<canvas class="zbz-fx"></canvas>');
    document.body.appendChild(cv);
    var ctx = cv.getContext('2d'), W, H;
    function size() { W = cv.width = innerWidth; H = cv.height = innerHeight; }
    size(); addEventListener('resize', size);
    var parts = [], t0 = Date.now(), DUR = 7000, raf;
    function burst() {
      var cx = W * (0.15 + Math.random() * 0.7), cy = H * (0.12 + Math.random() * 0.3);
      var hue = Math.floor(Math.random() * 360);
      for (var i = 0; i < 42; i++) {
        var a = Math.random() * Math.PI * 2, v = 2 + Math.random() * 3.6;
        parts.push({ x: cx, y: cy, vx: Math.cos(a) * v, vy: Math.sin(a) * v, life: 1, hue: hue, kind: 'fw' });
      }
    }
    function tick() {
      var dt = Date.now() - t0;
      ctx.clearRect(0, 0, W, H);
      if (mode === 'fireworks' && Math.random() < 0.025 && dt < DUR - 2500) burst();
      if (mode !== 'fireworks' && parts.length < 70 && dt < DUR - 3000) {
        parts.push({ x: Math.random() * W, y: -20, vx: (Math.random() - 0.5) * 0.7, vy: 0.6 + Math.random() * 1.4, life: 1, rot: Math.random() * 6, kind: mode });
      }
      parts = parts.filter(function (p) { return p.life > 0 && p.y < H + 30; });
      parts.forEach(function (p) {
        p.x += p.vx; p.y += p.vy;
        if (p.kind === 'fw') { p.vy += 0.045; p.life -= 0.016; ctx.globalAlpha = Math.max(0, p.life); ctx.fillStyle = 'hsl(' + p.hue + ',100%,62%)'; ctx.fillRect(p.x, p.y, 3, 3); }
        else if (p.kind === 'snow') { p.x += Math.sin(p.y / 40) * 0.4; ctx.globalAlpha = 0.8; ctx.fillStyle = '#fff'; ctx.beginPath(); ctx.arc(p.x, p.y, 2.4, 0, 7); ctx.fill(); }
        else { p.rot += 0.03; ctx.globalAlpha = 0.9; ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.rot); ctx.font = '22px serif'; ctx.fillText(emoji, -11, 8); ctx.restore(); }
      });
      ctx.globalAlpha = 1;
      // Hard stop at DUR with a quick fade — slow-drifting particles would
      // otherwise linger on screen long after spawning ends.
      if (dt < DUR) raf = requestAnimationFrame(tick);
      else if (dt < DUR + 700) { cv.style.transition = 'opacity 0.6s'; cv.style.opacity = '0'; raf = requestAnimationFrame(tick); }
      else cv.remove();
    }
    if (mode === 'fireworks') burst();
    raf = requestAnimationFrame(tick);
  }

  /* ================= 2) MATCHUP MODE (countdown click overlay) ============= */
  function oppHandle(oppNick) {
    if (!window.ZUBAZ_TEAMS) return null;
    var up = String(oppNick).toUpperCase();
    var keys = Object.keys(window.ZUBAZ_TEAMS);
    for (var i = 0; i < keys.length; i++) if (nick(window.ZUBAZ_TEAMS[keys[i]].name) === up) return keys[i];
    return null;
  }
  function productCards(handle, host) {
    // The per-collection filter index (same asset zbz-bigfilter renders from):
    // CDN-served, so no storefront bot-protection walls, and it carries the
    // best-seller rank. Derive its URL from the gameday asset URL.
    var base = GAMEDAY_URL ? GAMEDAY_URL.split('zbz-gameday.json')[0] : null;
    if (!base) return;
    fetch(base + 'zbz-filter-index-' + handle + '.json').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (d) {
      var picks = (d.products || []).filter(function (p) { return !p.so && p.im; })
        .sort(function (a, b) { return (a.r === undefined ? 1e9 : a.r) - (b.r === undefined ? 1e9 : b.r); })
        .slice(0, 4);
      host.innerHTML = picks.map(function (p) {
        var price = p.p == null ? '' : '<b>$' + (p.p % 1 ? p.p.toFixed(2) : p.p) + '</b>';
        return '<a class="zbz-mu__card" href="/products/' + esc(p.h) + '">' +
          '<img loading="lazy" src="' + esc(d.imgBase + p.im) + '?width=360" alt="">' +
          '<span>' + esc(p.t) + '</span>' + price + '</a>';
      }).join('');
    }).catch(function () { });
  }
  function matchup() {
    if (!GAMEDAY_URL) return false;
    var handle = pickedTeam(); if (!handle) return false;
    var T = window.ZUBAZ_TEAMS[handle];
    fetch(GAMEDAY_URL).then(function (r) { return r.json(); }).then(function (feed) {
      var g = feed.teams && feed.teams[handle]; if (!g) return;
      var oh = oppHandle(g.opp), O = oh ? window.ZUBAZ_TEAMS[oh] : null;
      var kick = new Date(g.kick);
      var when = kick.toLocaleDateString([], { weekday: 'long', month: 'short', day: 'numeric' }) + ' • ' + kick.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
      var old = document.getElementById('zbz-mu'); if (old) old.remove();
      var m = el('<div class="zbz-modal" id="zbz-mu">' +
        '<div class="zbz-modal__overlay"></div>' +
        '<div class="zbz-modal__panel zbz-modal__panel--mu" role="dialog" aria-label="Gameday matchup" style="--mua:' + T.primary + ';--mub:' + (O ? O.primary : '#333') + ';">' +
        '<button type="button" class="zbz-modal__close" aria-label="Close">×</button>' +
        '<p class="zbz-modal__kicker">' + (g.pre ? 'PRESEASON ' : '') + 'GAMEDAY MATCHUP</p>' +
        '<div class="zbz-mu__vs">' +
        '<div class="zbz-mu__team">' + (T.icon ? '<img src="' + T.icon + '&width=160" alt="">' : '') + '<b>' + esc(nick(T.name)) + '</b></div>' +
        '<span class="zbz-mu__x">' + (g.home ? 'VS' : '@') + '</span>' +
        '<div class="zbz-mu__team">' + (O && O.icon ? '<img src="' + O.icon + '&width=160" alt="">' : '') + '<b>' + esc(g.opp) + '</b></div>' +
        '</div>' +
        '<p class="zbz-mu__when">' + esc(when) + '</p>' +
        '<p class="zbz-mu__cta-line">THEIR FANS ARE SHOPPING TOO. OUT-DRESS THEM.</p>' +
        '<div class="zbz-mu__grid"></div>' +
        '<a class="button button--primary" href="/collections/' + esc(handle) + '">SHOP ALL ' + esc(nick(T.name)) + ' GEAR</a>' +
        '</div></div>');
      document.body.appendChild(m);
      productCards(handle, m.querySelector('.zbz-mu__grid'));
      m.addEventListener('click', function (e) {
        if (e.target.classList.contains('zbz-modal__close') || e.target.classList.contains('zbz-modal__overlay')) m.remove();
      });
    }).catch(function () { });
    return true;
  }
  window.zbzMatchup = matchup;

  /* ================= boot ================================================== */
  ready(function () {
    function boot() {
      if (!window.ZUBAZ_TEAMS) { setTimeout(boot, 300); return; }
      seasonKit();
      fanChrome();
    }
    boot();
    // Re-apply menu entry + accents whenever the shopper picks/changes/clears
    // a team (custom.js dispatches zubaz:team on every change).
    document.addEventListener('zubaz:team', function () { setTimeout(fanChrome, 50); });
  });
})();
